import useAjaxSelect2Store from "@scripts/hooks/use-ajax-select2-store";

export default (initial = {}) => ({
    storeName: initial.store ?? null,
    id: initial.id ?? null,
    singleChoice: Boolean(initial.singleChoice ?? false),
    storeProp: initial.storeProp ?? (initial.singleChoice ? null : "selectedEmployees"),
    placeholder: initial.placeholder ?? "Виберіть працівника",
    selectedEmployees: [],
    selectedEmployee: null,
    selectHook: null,

    init() {
        this.$nextTick(() => this._syncMultipleAttribute());

        const valueProp = this.singleChoice ? "selectedEmployee" : "selectedEmployees";
        if (typeof this[valueProp] === "undefined") {
            this[valueProp] = this.singleChoice ? null : [];
        }

        this.selectHook = useAjaxSelect2Store(this, {
            ref: "employeesSelect",
            storeName: this.storeName,
            storeProp: this.storeProp || valueProp,
            valueProp,
            restPath: "employees",
            multiple: this.singleChoice,
            placeholder: this.placeholder,
            processResults: (data) => data,
        });
    },

    _syncMultipleAttribute() {
        const el = this.$refs?.employeesSelect;
        if (!el) return;

        if (this.singleChoice) {
            el.removeAttribute("multiple");
        } else {
            el.setAttribute("multiple", "multiple");
        }
    },
});
